import {
  InsertDriveFileOutlined as FileIconMui,
  Folder as FolderIcon,
  Description as DescriptionIcon,
  Image as ImageIcon,
  VideoFile as VideoIcon,
  AudioFile as AudioIcon,
  Code as CodeIcon,
  PictureAsPdf as PdfIcon,
} from "@mui/icons-material";

export const FileIcon = ({ fileName, type }: any) => {
  if (type === "folder") {
    return <FolderIcon color="primary" />;
  }

  if (!fileName) return <FileIconMui />;

  const ext = fileName.split(".").pop()?.toLowerCase();

  switch (ext) {
    case "jpg":
    case "jpeg":
    case "png":
    case "gif":
    case "webp":
      return <ImageIcon />;
    case "mp4":
    case "avi":
    case "mov":
    case "mkv":
      return <VideoIcon />;
    case "mp3":
    case "wav":
    case "flac":
      return <AudioIcon />;
    case "pdf":
      return <PdfIcon />;
    case "js":
    case "ts":
    case "jsx":
    case "tsx":
    case "html":
    case "css":
    case "py":
    case "java":
      return <CodeIcon />;
    case "doc":
    case "docx":
    case "txt":
      return <DescriptionIcon />;
    default:
      return <FileIconMui />;
  }
};

export default FileIcon;
